import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

class SwitchBordCard extends React.Component {
  render() {
    const {
      Buttons,
      heading
    } = this.props;
    console.log("SwitchBordCard",Buttons);
    return (
      <div className="col-lg-12 col-md-12 col-sm-24">
        <div className="card">
          <div className="header">
            <h2>{heading}</h2>
            <div className="body">
              <ul className="list-unstyled basic-list ng-star-inserted">
                {!Buttons &&
                  <li><b>No data</b></li>
                }
                {Buttons && Buttons.map((Button, index) => {
                  return (
                    <li
                      key={index}
                      className={
                        Button.switch===true
                          ? "ng-star-inserted text-danger"
                          : "ng-star-inserted"
                      }
                    >
                      {Button.title}
                      <span
                        style={{width: "80px"}}
                        className={
                          Button.switch===true
                          ? "ng-star-inserted text-dark badge"
                          : "ng-star-inserted text-danger badge"
                        }
                      >
                        {Button.title == 'BRAKE STATUS'?(Button.switch ? "Active":"In-Active"):(Button.switch ? "Open":"Close")}
                      </span>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SwitchBordCard.propTypes = {};

export default (SwitchBordCard);
